// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"58":"a96c8223","78":"01bf4b1c","107":"744f3053","202":"a96c8223","976":"01bf4b1c","999":"a96c8223"}[chunkId] + ".chunk.css";
};